import { useState } from "react"
import { defaultLabels } from "./defaultLabels"
import { useLocation } from "@reach/router"

export const useGameProps = () => {
  const [labels, setLabels] = useState(defaultLabels)
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const [gameId] = useState(params.get("game-id"))

  const [strapiUrl] = useState(
    process.env.STRAPI_ENDPOINT || "https://dudwpkgwkyw9w.cloudfront.net"
  )

  return {
    labels,
    setLabels,
    gameId,
    strapiUrl,
  }
}
